'use client';

import { c as _c } from "react/compiler-runtime";
import type { OnrampClient } from '@morfi/onramp-sdk';
import { useFundingNavigation } from '@morfi/onramp-sdk/react';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { AnimatedButton } from '@/components/ui/animated-button';
import { TOAST_IDS } from '@/config/toast-ids';
import { copyToClipboard } from '@/lib/share/share';
import { logger } from '@/lib/telemetry/logger';
import { showToast } from '@/lib/ui/toast';
export function FundingReceiptActions(t0) {
  const $ = _c(16);
  const {
    client,
    reference
  } = t0;
  const t = useTranslations("onramp");
  const navigation = useFundingNavigation(client);
  let t1;
  if ($[0] !== reference || $[1] !== t) {
    t1 = async function copy() {
      let copied = false;
      try {
        copied = await copyToClipboard(reference);
        if (!copied) {
          logger.warn("onramp.receipt_copy_failed");
        }
      } catch {
        logger.warn("onramp.receipt_copy_failed");
      }
      showToast({
        id: TOAST_IDS.ONRAMP_RECEIPT_COPY,
        message: copied ? t("receipt_copied") : t("receipt_copy_failed"),
        variant: copied ? "success" : "error"
      });
    };
    $[0] = reference;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const copy = t1;
  let t2;
  if ($[3] !== t) {
    t2 = t("receipt_copy_reference");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== copy || $[6] !== t2) {
    t3 = <AnimatedButton variant="outline" className="h-11 flex-1 rounded-control" onClick={copy}>{t2}</AnimatedButton>;
    $[5] = copy;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = navigation.openHistory;
  let t5;
  if ($[8] !== t) {
    t5 = t("receipt_view_history");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== navigation.openHistory || $[11] !== t5) {
    t6 = <AnimatedButton className="h-11 flex-1 rounded-control" onClick={t4}>{t5}</AnimatedButton>;
    $[10] = navigation.openHistory;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t3 || $[14] !== t6) {
    t7 = <div className="flex flex-col gap-2"><div className="flex gap-2">{t3}{t6}</div></div>;
    $[13] = t3;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}